// Google Analytics tracking utilities

declare global {
  interface Window {
    gtag?: (
      command: string,
      targetId: string,
      config?: Record<string, any>
    ) => void;
  }
}

/**
 * Track a custom event in Google Analytics
 */
export const trackEvent = (
  eventName: string,
  eventParams?: Record<string, any>
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

/**
 * Track a pageview in Google Analytics
 */
export const trackPageView = (url: string, title?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-V326P3FNXB', {
      page_path: url,
      page_title: title,
    });
  }
};

/**
 * Track form submission
 */
export const trackFormSubmit = (
  formName: string,
  additionalData?: Record<string, any>
) => {
  trackEvent('form_submit', {
    form_name: formName,
    ...additionalData,
  });
};

/**
 * Track trial request submission
 */
export const trackTrialRequest = (
  role?: string,
  state?: string
) => {
  trackEvent('trial_request', {
    role: role,
    state: state,
    form_type: 'trial_request',
  });
};

/**
 * Track needs assessment submission
 */
export const trackNeedsAssessment = (
  inputType: 'text' | 'file',
  hasResults: boolean
) => {
  trackEvent('needs_assessment', {
    input_type: inputType,
    has_results: hasResults,
    form_type: 'district_needs',
  });
};
